<template>
  <div>
    <CCard >
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <CRow class="flex-flow-column">
          <CCol>
            <strong>{{ $t("scheduleAll.title") }}</strong>
          </CCol>

          <p class="desc">{{ $t("scheduleAll.desc") }}</p>
        </CRow>
      </CCardHeader>
      <ValidationObserver v-slot="{ handleSubmit,invalid }">
        <CCardBody class="user-manage-table pt-0px pb-0">
               <br>
          <div class="d-flex"  v-if="GET_SELECTED_CONTRACT&&GET_SELECTED_CONTRACT.contractcode">
          <h3>{{$t("contract.contractName")+' : '}}</h3>  <h3 class="text-transform-uppercase"> {{GET_SELECTED_CONTRACT&&GET_SELECTED_CONTRACT.contractcode}}</h3>
           </div>
            <div class="max-width-550 m-auto">
                <CRow>
                    <CAlert v-if="alertValue" show color="danger">
                        <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                            <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
                        </div>
                        <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                            <span>{{$t("cAlert.errorCode")+' : '}}</span>
                            <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
                        </div>
                        <div v-if="alertValue&&alertValue.constructor==String">
                            <p>{{alertValue}}</p>
                        </div>
                    </CAlert>
                </CRow>
                <br />
                <CRow v-if="GET_SEL_FLIGHT_SCHEDULE">
                <CCol md="3" sm="12">
                     <label>{{$t('scheduleAll.status')}}</label>

                </CCol>
                        <CCol md="3" sm="12">

                <div :class="{'active':flightSchedule.status==1}" @click="onChangeScheduleStatus(1)">
                  <img src="~@imgPath/img/svg/icons/active.svg" alt="" height="20px" >
                                       <label>{{$t('scheduleAll.activeTooltip')}}</label>

                </div>
                                </CCol>
                              <CCol md="3" sm="12">

                <div :class="{'active':flightSchedule.status==0}" @click="onChangeScheduleStatus(0)">
                  <img src="~@imgPath/img/svg/icons/play-circle.svg" alt="" height="20px" >
                                       <label>{{$t('scheduleAll.deactivatedTooltip')}}</label>

                </div>
                                </CCol>
                              <CCol md="3" sm="12">

                <div :class="{'active':flightSchedule.status==2}" @click="onChangeScheduleStatus(2)">
                  <img src="~@imgPath/img/svg/icons/pause-circle.svg" alt="" height="20px" >
                                       <label>{{$t('scheduleAll.pauseSellingToolip')}}</label>

                </div>
                                                </CCol>

              
                </CRow>                
                    
                <CRow>
                    <CCol md="6" sm="12">
                        <label>{{$t('scheduleAll.from')}}</label>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <multiselect
                                    v-model="flightSchedule.from"
                                    label="airportcode"
                                    :allow-empty="false"
                                    :options="lsAirportCodes"
                                    :track-by="'airportcode'"
                                    deselectLabel
                                    deselectGroupLabel
                                    selectLabel
                                    selectedLabel
                                    :placeholder="$t('scheduleAll.depCityPl')"
                                    @input="isValidSchedule(flightSchedule)"
                            >
                                <template #noResult>
                                    <strong>{{$t('scheduleAll.listEmpty')}}</strong>
                                </template>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                            <div v-if="!(errors && errors[0])&&depAlertValue" class="invalid-feedback icon">
                                <span>{{ depAlertValue }}</span>
                            </div>
                        </ValidationProvider>
                    </CCol>

                    <CCol md="6" sm="12">
                        <label>{{$t('scheduleAll.to')}}</label>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <multiselect
                                    v-model="flightSchedule.to"
                                    label="airportcode"
                                    :allow-empty="false"
                                    :options="lsAirportCodes"
                                    :track-by="'airportcode'"
                                    deselectLabel
                                    deselectGroupLabel
                                    selectLabel
                                    selectedLabel
                                    :placeholder="$t('scheduleAll.arrCityPl')"
                                    @input="isValidSchedule(flightSchedule)"
                            >
                                <template #noResult>
                                    <strong>{{$t('scheduleAll.listEmpty')}}</strong>
                                </template>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                            <div v-if="!(errors && errors[0])&&arrAlertValue" class="invalid-feedback icon">
                                <span>{{ arrAlertValue }}</span>
                            </div>
                        </ValidationProvider>
                    </CCol>
                </CRow>
                <br />
                <CRow>
                    <CCol md="6" sm="12">
                        <label>{{$t('scheduleAll.airline')}}</label>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <multiselect
                                    v-model="flightSchedule.airline"
                                  
                                    :allow-empty="false"
                                    :options="lsAirlines"
                                    :track-by="'airline_code'"
                                    deselectLabel
                                    deselectGroupLabel
                                    selectLabel
                                    selectedLabel
                                    :placeholder="$t('scheduleAll.airlineCodePl')"
                            >
                             <template slot="singleLabel" slot-scope="{ option }">
                                    <div class="d-flex">
                                     <span>{{ option['airline_name'] }}</span>
                                        <strong class="right ml-auto">
                                          {{
                                          option['airline_code']
                                          }}
                                        </strong>
                                    </div>
                                </template>
                                 <template slot="option" slot-scope="props">
                                    <div class="d-flex">
                                        <span>{{ props.option['airline_name'] }}</span>
                                        <strong class="right ml-auto">
                                          {{
                                          props.option['airline_code']
                                          }}
                                        </strong>
                                    </div>
                                </template>
                                <template #noResult>
                                    <strong>{{$t('scheduleAll.listEmpty')}}</strong>
                                </template>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </CCol>
                    <CCol md="6" sm="12">
                        <!--              <label>{{$t('scheduleAll.airline')}}</label>-->
                        <cTextInputComponent
                                v-model="flightSchedule.flightNumber"
                                :placeholder="$t('scheduleAll.flightNumPl')"
                                rules="required|max:4|onlynumber"
                                label="Flight Number"
                        />
                    </CCol>

                </CRow>
                <br />
                <CRow>
                    <CCol md="6" sm="12">
                       <ValidationProvider :rules="'required'" v-slot="{ errors }">

                         <label>{{$t('scheduleAll.aircraftType')}}</label>
                        <multiselect
                                v-model="flightSchedule.aircraftType"
                                label="name"
                                :allow-empty="false"
                                :options="lsAircraftType"
                                :track-by="'code'"
                                deselectLabel
                                deselectGroupLabel
                                selectLabel
                                selectedLabel
                                :placeholder="$t('scheduleAll.aircraftTypePl')"
                        >
                            <template #noResult>
                                <strong>{{$t('scheduleAll.listEmpty')}}</strong>
                            </template>
                        </multiselect>
                           <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                    <span>{{ errors[0] }}</span>
                                </div>
                                

                            </ValidationProvider>
<!-- 
                        <div class="d-flex flex-flow-column">



                            <cTextInputComponent
                                    v-model="flightSchedule.aircraftType"
                                    :placeholder="$t('scheduleAll.aircraftTypePl')"
                                    rules="required|noSplCharExceptHyphen|Atmax:30"
                                    :label="$t('scheduleAll.aircraftType')"
                                    :name="$t('scheduleAll.aircraftType').toLowerCase()"
                                    :vid="$t('scheduleAll.aircraftType')+'id'"

                            />
                        </div> -->
                    </CCol>
                    <CCol md="6" sm="12">
                        <label>{{$t('scheduleAll.via')}}</label>
                        <multiselect
                                v-model="flightSchedule.via"
                                label="airportcode"
                                :allow-empty="true"
                                :options="lsAirportCodes"
                                :track-by="'airportcode'"
                                deselectLabel
                                deselectGroupLabel
                                selectLabel
                                selectedLabel
                                :placeholder="$t('scheduleAll.viaPl')"
                        >
                            <template #noResult>
                                <strong>{{$t('scheduleAll.listEmpty')}}</strong>
                            </template>
                        </multiselect>
                    </CCol>
                </CRow>
                <br />
                <CRow>
                    <CCol md="6" sm="12"  class="d-flex">
                        <div class="d-flex flex-flow-column span-100 w-100 max-w-140px">


                            <label>{{$t('scheduleAll.departureTime')}}</label>
                            <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                <vue-timepicker  ref="depTimePick"
                                        class="input-normal w-100"
                                        v-model="flightSchedule.departureTime"
                                        :format="DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT"
                                        :minute-interval="5"
                                        close-on-complete
                                        hide-clear-button
                                        @open="toggleTimePickAnimClass('depTimePick')"
                                        @close="toggleTimePickAnimClass('depTimePick'),isValidSchedule(flightSchedule)"
                                />
<!--                                <icon>-->

<!--                                </icon>-->
                                <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                    <span>{{ errors[0] }}</span>
                                </div>
                                

                            </ValidationProvider>
                        </div>
                    </CCol>
                    <CCol md="4" sm="8" class="d-flex ">
                        <div class="d-flex flex-flow-column span-100 w-100 max-w-140px">
                            <label>{{$t('scheduleAll.arrivalTime')}}</label>
                            <ValidationProvider :rules="'required'" v-slot="{ errors }" >
                                    <vue-timepicker ref="arrTimePick"
                                        class="input-normal w-100"
                                        v-model="flightSchedule.arrivalTime"
                                        :format="DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT"
                                        :minute-interval="5"
                                        close-on-complete
                                        hide-clear-button
                                         @open="toggleTimePickAnimClass('arrTimePick')"
                                         @close="toggleTimePickAnimClass('arrTimePick'),isValidSchedule(flightSchedule)"



                                />
                                <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                    <span>{{ errors[0] }}</span>
                                </div>
                                 <div v-if="!(errors && errors[0])&&arrTimeAlertValue" class="invalid-feedback icon">
                                <span>{{ arrTimeAlertValue }}</span>
                            </div>
                            </ValidationProvider>
                        </div>
                    </CCol>

                    <CCol md="2" sm="4" class="d-flex ">
                       <div class="d-flex  span-100 w-100 align-items-end pb-10px">
                      <input 
                      v-model="flightSchedule.arrtime_nextday"
                       type="checkbox" 
                       id="Next-Day"
                        class="input-normal w-100"
                       style="margin: 0px 0px 3px -14px;"
                       @change="isValidSchedule(flightSchedule)"
                       />
                       <label for="Next-Day" class="white-space-pre mb-0px align-item-center d-flex">{{$t('scheduleAll.nextDay')}}</label>
                       </div>
                    </CCol>

                </CRow>
                <!-- <CRow> -->
                <br />

                <CRow>
                    <CCol md="6" sm="12">
                        <!--              <label>{{$t('scheduleAll.saleableBusinessSeats')}}</label>-->
                        <cTextInputComponent
                                v-model="flightSchedule.saleableBusinessSeats"
                                :placeholder="$t('scheduleAll.saleableBusinessSeatsPl')"
                                rules="required|onlyNumber|max:4"
                                :label="$t('scheduleAll.saleableBusinessSeats')"
                                :maxLength="4"
                        />
                    </CCol>
                    <CCol md="6" sm="12">
                        <!--              <label>{{$t('scheduleAll.saleableEconomySeats')}}</label>-->

                        <cTextInputComponent
                                v-model="flightSchedule.overbookingBSeats"
                                :placeholder="$t('scheduleAll.saleableBusinessSeatsPl')"
                                rules="required|onlyNumber|max:4"
                                :label="$t('scheduleAll.overBookSaleableBusinessSeats')"
                                 :maxLength="4"
                        />
                    </CCol>

                </CRow>
                <br />
<CRow>
                    <CCol md="6" sm="12">
                        <!--              <label>{{$t('scheduleAll.saleableBusinessSeats')}}</label>-->
                        <cTextInputComponent
                                v-model="flightSchedule.saleableEconomySeats"
                                :placeholder="$t('scheduleAll.saleableEconomySeatsPl')"
                                rules="required|onlyNumber|max:4"
                                :label="$t('scheduleAll.saleableEconomySeats')"
                                 :maxLength="4"
                        />
                    </CCol>
                    <CCol md="6" sm="12">
                        <!--              <label>{{$t('scheduleAll.saleableEconomySeats')}}</label>-->

                        <cTextInputComponent
                                v-model="flightSchedule.overbookingESeats"
                                :placeholder="$t('scheduleAll.saleableEconomySeatsPl')"
                                rules="required|onlyNumber|max:4"
                                :label="$t('scheduleAll.overBookSaleableEconomySeats')"
                                 :maxLength="4"
                        />
                    </CCol>

                </CRow>

                <br />

                <CRow class="mt-15px">
                    <CCol v-for="(schedule,index) in lsScheduleType" :key="index">
                        <button
                                class="tab-button"

                                @click="getSchedules(schedule,true)"
                                :class="{active :schedule.value==flightSchedule.scheduleType?true:false}"
                        >{{schedule.name}}</button>
                    </CCol>
                    <span class="d-flex">
                          <cHelpTip :content="$t('helpTip.crsFlightScheduleNewType')"></cHelpTip>
                        </span>
                </CRow>

            </div>

<div class="button-day-partten">
    <!-- <ValidationProvider :rules="'required'" v-slot="{ errors }"> -->
        <div v-if="flightSchedule.scheduleType==1">
            <CRow v-model="flightSchedule.schedules[0]" class="m-auto d-flex justify-center mt-15px mb-15px max-width-550 ">
                <button
                        @click="onSaveSchedule(scheduleValue)"
                        v-for="(scheduleValue,index) in lsScheduleValues"
                        :key="index"
                        :class="{active : scheduleValue.isActive }"

                >{{scheduleValue.value}}</button>
            </CRow>
        </div>

        <div v-if="flightSchedule.scheduleType==2" class="m-auto mt-15px mb-15px max-width-550 ">
            <CRow  class="d-flex justify-center day-row"
                    v-model="flightSchedule.schedules[0]"
                    v-for="(rowValue,rowIndex) in Math.ceil(lsScheduleValues.length/7)"
                    :key="rowIndex"
            >
                <div v-for="(scheduleValue,index) in lsScheduleValues" :key="index" class="days-btn-wrap-cel" >
                 <div class="tab-wrap" v-if="onShowScheduleGrid(rowIndex,scheduleValue)">
                    <button
                            :class="{active : scheduleValue.isActive }"
                            @click="onSaveSchedule(scheduleValue)"

                            v-if="onShowScheduleGrid(rowIndex,scheduleValue)"
                    >{{ scheduleValue.value }}</button>
                    </div>
                </div>
<!--                :style="{color:scheduleValue.isActive?'blue':''}"-->
            </CRow>
        </div>
        <!-- <div
                v-if="errors && errors[0]&&flightSchedule.schedules.length<=0"
                class="invalid-feedback icon"
        >
            <span>{{ errors[0] }}</span>
        </div>
    </ValidationProvider> -->
    <div v-if="flightSchedule.schedules.length<=0">
      <span v-if="flightSchedule.scheduleType==lsScheduleType[0].value">{{$t('scheduleAll.allDaysSelected')}} </span>
       <span v-if="flightSchedule.scheduleType==lsScheduleType[1].value">{{$t('scheduleAll.allDatesSelected')}} </span>
    </div>
    <div class="date-description"   v-else>
      <div v-if="flightSchedule.scheduleType==lsScheduleType[0].value" class="m-auto mt-15px mb-15px max-width-550">
      <span >{{lsScheduleType[0].name+' - '}}</span><span v-for="(schedule,index) in flightSchedule.schedules" :key="index">
        {{flightSchedule.schedules[index]}}{{flightSchedule.schedules.length==0||index==flightSchedule.schedules.length-1?' ':index==flightSchedule.schedules.length-2?' & ':','}}
      </span><span>{{flightSchedule.schedules.length==1?$t('scheduleAll.isSelected'):$t('scheduleAll.areSelected')}}</span>
      </div>
       <div v-if="flightSchedule.scheduleType==lsScheduleType[1].value"  class="m-auto mt-15px mb-15px max-width-550">
      <span >{{lsScheduleType[1].name+' - '}}</span><span v-for="(schedule,index) in flightSchedule.schedules" :key="index">
        {{flightSchedule.schedules[index]}}{{flightSchedule.schedules.length==0||index==flightSchedule.schedules.length-1?' ':index==flightSchedule.schedules.length-2?' & ':','}}
      </span><span>{{flightSchedule.schedules.length==1?$t('scheduleAll.isSelected'):$t('scheduleAll.areSelected')}}</span>

      </div>

    </div>
</div>

          <!-- </CRow> -->
          <CCardFooter>
            <CRow class="justify-content-end ">
              <CButton @click="navToScheduleAll" color="danger" class="action-c-btn mr-15px">{{$t('scheduleAll.cancelBtn')}}</CButton>
              <CButton
                col="12"
                color="success removewrap"
                class="action-c-btn"
                @click.prevent="handleSubmit(onShowCreateScheduleModal),invalid?isValidSchedule(flightSchedule):alertValue=null"
              >{{GET_SEL_FLIGHT_SCHEDULE?$t('scheduleAll.updateBtn'):$t('scheduleAll.createBtn')}}</CButton>
            </CRow>
          </CCardFooter>

          <!-- table filter hidded
          tableFilter-->
          <!-- <button class="mf-success-round-btn">Apply</button> -->
        </CCardBody>
      </ValidationObserver>
        <cAlertModal
      v-if="isCreateScheduleModal"
      :buttonList="[{
              name:$t('scheduleAll.noBtn'),func:onHideConfirmationModals,color:'danger'},
                {name:$t('scheduleAll.yesBtn'),func:onCreateFlightSchedule,color:'success'},]"
      :status="2"
      :show="isCreateScheduleModal"
      :desc="GET_SEL_FLIGHT_SCHEDULE?$t('scheduleAll.updateScheduleConfirmation'):$t('scheduleAll.createScheduleConfirmation')"
    ></cAlertModal>
   
    <cAlertModal
      v-if="isScheduleCreated"
      :buttonList="[{name:$t('scheduleAll.okBtn'),func:onHideConfirmationModals,color:'success'}]"
      :status="1"
      :show="isScheduleCreated"
      :desc="GET_SEL_FLIGHT_SCHEDULE?$t('scheduleAll.scheduleUpdatedSuccDesc'):$t('scheduleAll.scheduleCreatedSuccDesc')"
    ></cAlertModal>
   
    <cAlertModal
      v-if="isFailedModal"
      :buttonList="[{name:$t('scheduleAll.okBtn'),func:onHideConfirmationModals,color:'danger'}]"
      :status="0"
      :show="isFailedModal"
      :desc="alertValue"
    ></cAlertModal>
    </CCard>

  

  </div>
</template>

<script>
import router, { navigate, updateDataEdited } from "../../../../router/index";

import { mapGetters, mapActions } from "vuex";
import { PATHNAME, COMPONENT_NAME, ORDER ,DATE_TIME_FORMAT} from "../../../../util/constants";
import Logger from "../../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "../../../../config/API_DATA";

import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneData
} from "../../../../util/util";
import BaseConfiguration from "../../../../config/base.js";
import apiGetAirports from "../../../../services/apiGetAirports";
import Multiselect from "vue-multiselect";
import apiGetAllAirlines from "../../../../services/apiGetAllAirlines";
import cTextInputComponent from "../../../../components/form/cTextInputComponent";
// import nb from "../../../../translations/validation/nb.json";
// import en from "../../../../translations/validation/en.json";
import { ValidationObserver, ValidationProvider, localize } from "vee-validate";
// import VueTimepicker from "vue2-timepicker";
import apiCreateFlightSchedule from "../../../../services/apiCreateFlightSchedule";
import cAlertModal from "../../../../components/form/cAlertModal";
import apiUpdateFlightSchedule from "../../../../services/apiUpdateFlightSchedule";
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import cHelpTip from "../../../../components/cHelpTip";
    import { i18n } from "../../../../plugins/i18n.js";
import apiChangeFlightScheduleStatus from "../../../../services/apiChangeFlightScheduleStatus";

// localize({
//   en: {
//     messages: en.messages
//   },
//   nb: {
//     messages: nb.messages
//   }
// });
export default {
  name: COMPONENT_NAME.SCHEDULE_NEW,
  components: {
    Multiselect,
    cTextInputComponent,
    ValidationObserver,
    ValidationProvider,
    VueTimepicker,
    cAlertModal,
    cHelpTip
  },

  data: () => {
    return {
      alertValue: null,
      lsAirlines: [],
      lsAirportCodes: [],
      flightSchedule: {
        from: null,
        to: null,
        airline: null,
        flightNumber: null,
        aircraftType: null,
        via: null,
        departureTime:{
          HH: "00",
            mm:"00"
        } ,
        arrivalTime:{
          HH: "00",
            mm:"00"
        } ,
        saleableBusinessSeats: null,
        saleableEconomySeats: null,
        overbookingBSeats:null,
        overBookingESeats:null,
        scheduleType: null,
        schedules: [],
        scheduleId:null,
        arrtime_nextday:false,
        status:null
      },
      lsScheduleType: [
        {
          name:i18n.tc('scheduleAll.weekly'),
          value: 1
        },
        {
          name: i18n.tc('scheduleAll.monthly'),
          value: 2
        }
      ],
      lsScheduleValues: [],
      isCreateScheduleModal:false,
      isScheduleCreated:false,
      isFailedModal:false,
      depAlertValue:null,
      arrAlertValue:null,
      arrTimeAlertValue:null,
      lsAircraftType:[]
    };
  },

  methods: {

      onChangeScheduleStatus(pStatus) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeScheduleStatus");
        this.flightSchedule.status=pStatus;
        
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in onChangeScheduleStatus",
          err.toString(),
          "onChangeScheduleStatus",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toggleTimePickAnimClass(pRef) {
        try {
          if(BaseConfiguration.isDebug) console.log("toggleTimePickAnimClass");
           if(this.$refs&&this.$refs[pRef]&&this.$refs[pRef].$el&&this.$refs[pRef].$el.childNodes){
      for(let i=0;i<this.$refs[pRef].$el.childNodes.length;i++){
        if(this.$refs[pRef].$el.childNodes[i].className&&this.$refs[pRef].$el.childNodes[i].className.includes('dropdown')){
          if(this.$refs[pRef].$el.childNodes[i].classList.contains('active')){
             this.$refs[pRef].$el.childNodes[i].classList.remove('active');
          }else{
          this.$refs[pRef].$el.childNodes[i].classList.add('active');
          }
        }
      }
     }
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.SCHEDULE_NEW,
                  "error in toggleTimePickAnimClass",
                  err.toString(),
                  "toggleTimePickAnimClass",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
        
    onShowCreateScheduleModal() {
        try {
          if(BaseConfiguration.isDebug) console.log("onShowCreateScheduleModal");
         if(this.isValidSchedule(this.flightSchedule)){
         this.isCreateScheduleModal=true;

         }

        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.SCHEDULE_NEW,
                  "error in onShowCreateScheduleModal",
                  err.toString(),
                  "onShowCreateScheduleModal",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
        isValidSchedule(pFlightSchedule) {
          let retValue=true;
            try {
              if(BaseConfiguration.isDebug) console.log("isValidSchedule");
              this.depAlertValue = null;
              this.arrAlertValue = null;
                  this.arrTimeAlertValue = null;

                 var moment = require("moment");
              if(pFlightSchedule){
                if(pFlightSchedule.from && (pFlightSchedule.from==pFlightSchedule.to||pFlightSchedule.from==pFlightSchedule.via)){
              this.depAlertValue=this.$t('scheduleAll.depArrViaNotEqual');
              retValue= false;
                }else if(pFlightSchedule.to && (pFlightSchedule.to==pFlightSchedule.via)){
              this.arrAlertValue=this.$t('scheduleAll.depArrViaNotEqual');
              retValue= false;
                }
              
                if(!pFlightSchedule.arrtime_nextday){
                if(pFlightSchedule.departureTime&&pFlightSchedule.departureTime.HH&&pFlightSchedule.departureTime.mm&&pFlightSchedule.arrivalTime&&pFlightSchedule.arrivalTime.HH&&pFlightSchedule.arrivalTime.mm){
                  
                   if(!this.flightSchedule.arrtime_nextday&& moment(pFlightSchedule.departureTime.HH+pFlightSchedule.departureTime.mm)>moment(pFlightSchedule.arrivalTime.HH+pFlightSchedule.arrivalTime.mm)){
                     this.arrTimeAlertValue=this.$t('scheduleAll.arrTimeIfNotNextday');
                      retValue= false;
                   }
                }
                }
              }else{
              retValue= false;
              }
            } catch (err) {
                    let body = Logger.buildRequest(
                       COMPONENT_NAME.SCHEDULE_NEW,
                      "error in isValidSchedule",
                      err.toString(),
                      "isValidSchedule",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
              return retValue;
            },

      onHideConfirmationModals() {
      try {
        if (BaseConfiguration.isDebug) console.log("onHideConfirmationModals");

        this.isCreateScheduleModal = false;
        this.isFailedModal = false;

        if(this.isScheduleCreated){
          navigate(PATHNAME.SCHEDULE_ALL);
        this.isScheduleCreated = false;

        }
       
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in onHideConfirmationModals",
          err.toString(),
          "onHideConfirmationModals",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
      navToScheduleAll() {
          try {
            if(BaseConfiguration.isDebug) console.log("navToScheduleAll");    
          navigate(PATHNAME.SCHEDULE_ALL);
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.SCHEDULE_NEW,
                    "error in navToScheduleAll",
                    err.toString(),
                    "navToScheduleAll",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
          }, 

    onShowScheduleGrid(pRowIndex, pScheduleValue) {
      let retValue = false;
      try {
        if (BaseConfiguration.isDebug) console.log("onShowScheduleGrid");
        if (pRowIndex == 0) {
          if (pScheduleValue.value >= 1 && pScheduleValue.value <= 7) {
            retValue = true;
          }
        } else {
          if (
            pScheduleValue.value >= 7 * pRowIndex + 1 &&
            pScheduleValue.value <= 7 * (pRowIndex + 1)
          ) {
            retValue = true;
          }
        }

        //   rowIndex==0?scheduleValue.value>=1&&scheduleValue.value<=7:scheduleValue.value>=(7*rowIndex)+1&&scheduleValue.value<=7*(rowIndex+1)
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in onShowScheduleGrid",
          err.toString(),
          "onShowScheduleGrid",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    onSaveSchedule(pSchedule) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSaveSchedule");
        for (let i = 0; i <= this.lsScheduleValues.length; i++) {
          if (pSchedule.value == this.lsScheduleValues[i].value) {
            this.lsScheduleValues[i].isActive = !pSchedule.isActive;
            break;
          }
        }
        this.flightSchedule.schedules = this.saveScheduleValues(
          this.lsScheduleValues
        );
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in onSaveSchedule",
          err.toString(),
          "onSaveSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    saveScheduleValues(pLsScheduleValues) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("saveScheduleValues");
        for (let i = 0; i < pLsScheduleValues.length; i++) {
          if (pLsScheduleValues[i].isActive) {
            retValue.push(pLsScheduleValues[i].value);
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in saveScheduleValues",
          err.toString(),
          "saveScheduleValues",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getSchedules(pScheduleType,pIsDefaultActive) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSchedules");
        this.lsScheduleValues = [];
        this.flightSchedule.schedules=[];
        this.flightSchedule.scheduleType = pScheduleType.value;
        if (pScheduleType.value == 2) {
          //   this.lsScheduleValues = 31;
          for (let i = 1; i <= 31; i++) {
            let schedule = {
              value: i,
              isActive: pIsDefaultActive
            };
            this.lsScheduleValues.push(schedule);
          }
        } else if (pScheduleType.value == 1) {
          let lsWeekly = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
          for (let i = 0; i < lsWeekly.length; i++) {
            let schedule = {
              value: lsWeekly[i],
              isActive: pIsDefaultActive
            };
            this.lsScheduleValues.push(schedule);
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in getSchedules",
          err.toString(),
          "getSchedules",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async getAirportCodes() {
      let airportList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getAirportCodes");
        let airportRequest = apiGetAirports.buildRequest();

        if (airportRequest) {
          let airportResponse = await apiGetAirports.getResponse(
            airportRequest
          );

          if (VALIDATE_SUCCESS_RES(airportResponse)) {
            this.alertValue = null;
            airportList = airportResponse.data.data;
          } else {
            let error = getErrorMessage(airportResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in getAirportCodes",
          err.toString(),
          "getAirportCodes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return airportList;
    },

    async getAllAirlines() {
      let airportList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getAllAirlines");
        let pGetAllAirlineReq = {
          contractcode: "",
          description: "",
          airline_code: "",
          traveldate_from: "",
          traveldate_to: "",
          ticketingdate_from: "",
          ticketingdate_to: "",
          isfareonly_contract: "",
          providerid: null
        };
        let airportRequest = apiGetAllAirlines.buildRequest(pGetAllAirlineReq);

        if (airportRequest) {
          let airportResponse = await apiGetAllAirlines.getResponse(
            airportRequest
          );

          if (VALIDATE_SUCCESS_RES(airportResponse)) {
            this.alertValue = null;
            airportList = airportResponse.data.data;
          } else {
            let error = getErrorMessage(airportResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in getAllAirlines",
          err.toString(),
          "getAllAirlines",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return airportList;
    },
     async changeFlightSchedule(pScheduleId, pStatus) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("changeFlightSchedule");

        let flightScheduleReq = apiChangeFlightScheduleStatus.buildRequest(
          pScheduleId,
          pStatus
        );

        if (flightScheduleReq) {
          let flightScheduleRes = await apiChangeFlightScheduleStatus.getResponse(
            flightScheduleReq
          );
          if (VALIDATE_SUCCESS_RES(flightScheduleRes)) {
                        this.alertValue=null;

            retValue = flightScheduleRes.data.data.isStatusChanged;
          } else {
            let error = getErrorMessage(flightScheduleRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in changeFlightSchedule",
          err.toString(),
          "changeFlightSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async onCreateFlightSchedule() {
      try {
        if (BaseConfiguration.isDebug) console.log("onCreateFlightSchedule");
       updateDataEdited(false);

        // if (getAllAirlineReq) {
          if (this.GET_SEL_FLIGHT_SCHEDULE) {
                  let flightScheduleReq = this.updateFlightScheRequest(
          this.flightSchedule
        );
        if(flightScheduleReq){
           this.isCreateScheduleModal=false;

            let retFlightScheRes= await this.updateFlightSchedule(flightScheduleReq);
            if(this.GET_SEL_FLIGHT_SCHEDULE.scheduleid){
             await this.changeFlightSchedule(this.GET_SEL_FLIGHT_SCHEDULE.scheduleid,this.flightSchedule.status);
             
            }
           if(retFlightScheRes){
             this.isScheduleCreated=true;
           }else{
             this.isFailedModal=true;
           }
        }else{
                    throw "invalid request";

        }
         
          } else {
             let flightScheduleReq = this.createFlightScheRequest(
          this.flightSchedule
        );
         if(flightScheduleReq){
           this.isCreateScheduleModal=false;
          let retFlightScheRes= await this.createFlightSchedule(flightScheduleReq);
           if(retFlightScheRes){
             this.isScheduleCreated=true;
           }else{
             this.isFailedModal=true;
           }
          }
           else {
          throw "invalid request";
        }
          }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in onCreateFlightSchedule",
          err.toString(),
          "onCreateFlightSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    createFlightScheRequest(pFlightSchedule) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createFlightScheRequest");

        retValue = {
          contract:this.GET_SELECTED_CONTRACT?this.GET_SELECTED_CONTRACT.contractid:null,
          depcode: pFlightSchedule.from.airportcode,
          arrcode: pFlightSchedule.to.airportcode,
          airline_code:
            pFlightSchedule.airline && pFlightSchedule.airline.airline_code
              ? pFlightSchedule.airline.airline_code
              : null,
          flight_number: pFlightSchedule.flightNumber,
          aircraft_type: pFlightSchedule.aircraftType?pFlightSchedule.aircraftType.code:null,
          via_airport_code:
            pFlightSchedule.via && pFlightSchedule.via.airportcode
              ? pFlightSchedule.via.airportcode
              : null,
          deptime:
            pFlightSchedule.departureTime.HH +
            ":" +
            pFlightSchedule.departureTime.mm,
          arrtime:
            pFlightSchedule.arrivalTime.HH +
            ":" +
            pFlightSchedule.arrivalTime.mm,
          business_seats: Number(pFlightSchedule.saleableBusinessSeats),
          economy_seats: Number(pFlightSchedule.saleableEconomySeats),
          overbooking_business_seats: Number(pFlightSchedule.overbookingBSeats),
          overbooking_economy_seats: Number(pFlightSchedule.overbookingESeats),
          schedule_type: pFlightSchedule.scheduleType,
          schedules: pFlightSchedule.schedules&&pFlightSchedule.schedules.length>0?pFlightSchedule.schedules:this.getAllSchedulesByType(pFlightSchedule.scheduleType),
          arrtime_nextday:pFlightSchedule.arrtime_nextday

        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in createFlightScheRequest",
          err.toString(),
          "createFlightScheRequest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getAllSchedulesByType(pScheduleType) {
                let retValue=[];

        try {
          if(BaseConfiguration.isDebug) console.log("getAllSchedulesByType");
          if(pScheduleType==1){
            retValue=["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]
          }else if(pScheduleType==2){
            for (let i = 1; i <= 31; i++) {
            retValue.push(i);
            }
          }
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.SCHEDULE_NEW,
                  "error in getAllSchedulesByType",
                  err.toString(),
                  "getAllSchedulesByType",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

     updateFlightScheRequest(pFlightSchedule) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateFlightScheRequest");

        retValue = {
          scheduleid:Number(pFlightSchedule.scheduleId),
          depcode: pFlightSchedule.from.airportcode,
          arrcode: pFlightSchedule.to.airportcode,
          airline_code:
            pFlightSchedule.airline && pFlightSchedule.airline.airline_code
              ? pFlightSchedule.airline.airline_code
              : null,
          flight_number: pFlightSchedule.flightNumber,
          aircraft_type: pFlightSchedule.aircraftType?pFlightSchedule.aircraftType.code:null,
          via_airport_code:
            pFlightSchedule.via && pFlightSchedule.via.airportcode
              ? pFlightSchedule.via.airportcode
              : null,
          deptime:
            pFlightSchedule.departureTime.HH +
            ":" +
            pFlightSchedule.departureTime.mm,
          arrtime:
            pFlightSchedule.arrivalTime.HH +
            ":" +
            pFlightSchedule.arrivalTime.mm,
          business_seats: Number(pFlightSchedule.saleableBusinessSeats),
          economy_seats: Number(pFlightSchedule.saleableEconomySeats),
          overbooking_business_seats: Number(pFlightSchedule.overbookingBSeats),
          overbooking_economy_seats:Number(pFlightSchedule.overbookingESeats),
          schedule_type: pFlightSchedule.scheduleType,
          schedules: pFlightSchedule.schedules&&pFlightSchedule.schedules.length>0?pFlightSchedule.schedules:this.getAllSchedulesByType(pFlightSchedule.scheduleType),
          arrtime_nextday:pFlightSchedule.arrtime_nextday
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in updateFlightScheRequest",
          err.toString(),
          "updateFlightScheRequest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async createFlightSchedule(pFlightScheduleReq) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createFlightSchedule");
        let scheduleRequest = apiCreateFlightSchedule.buildRequest(
          pFlightScheduleReq
        );

        if (scheduleRequest) {
          let scheduleResponse = await apiCreateFlightSchedule.getResponse(
            scheduleRequest
          );

          if (VALIDATE_SUCCESS_RES(scheduleResponse)) {
            this.alertValue = null;
            retValue = scheduleResponse.data.data;
          } else {
            let error = getErrorMessage(scheduleResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in createFlightSchedule",
          err.toString(),
          "createFlightSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

     async updateFlightSchedule(pFlightScheduleReq) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateFlightSchedule");
        let scheduleRequest = apiUpdateFlightSchedule.buildRequest(
          pFlightScheduleReq
        );

        if (scheduleRequest) {
          let scheduleResponse = await apiUpdateFlightSchedule.getResponse(
            scheduleRequest
          );

          if (VALIDATE_SUCCESS_RES(scheduleResponse)) {
            this.alertValue = null;
            retValue = scheduleResponse.data.data;
          } else {
            let error = getErrorMessage(scheduleResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in updateFlightSchedule",
          err.toString(),
          "updateFlightSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getAirlineObj(pAirlineCode, pLsAirlines) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getAirlineObj");
        if (pAirlineCode && pLsAirlines) {
          for (let i = 0; i < pLsAirlines.length; i++) {
            if (pLsAirlines[i].airline_code == pAirlineCode) {
              retValue = pLsAirlines[i];
              break;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in getAirlineObj",
          err.toString(),
          "getAirlineObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },


    getRouteObj(pAirlineCode, pLsAirportCodes) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getRouteObj");
        if (pAirlineCode && pLsAirportCodes) {
          for (let i = 0; i < pLsAirportCodes.length; i++) {
            if (pLsAirportCodes[i].airportcode == pAirlineCode) {
              retValue = pLsAirportCodes[i];
              break;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in getRouteObj",
          err.toString(),
          "getRouteObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getScheduleTypeObj(pScheduleType, pLsScheduleTypes) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getScheduleTypeObj");
        if (pScheduleType && pLsScheduleTypes) {
          for (let i = 0; i < pLsScheduleTypes.length; i++) {
            if (pLsScheduleTypes[i].value == pScheduleType) {
              retValue = pLsScheduleTypes[i];
              break;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in getScheduleTypeObj",
          err.toString(),
          "getScheduleTypeObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },


    assignScheduleValuesAsActive(pFlightSchedule) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getScheduleTypeObj");
        let retScheduleTypeObj = this.getScheduleTypeObj(
          pFlightSchedule.scheduleType,
          this.lsScheduleType
        );

        this.getSchedules(retScheduleTypeObj,false);
        if (pFlightSchedule) {
          let lsScheduleValues = cloneData(this.lsScheduleValues);
          for (let i = 0; i < pFlightSchedule.schedules.length; i++) {
            for (let j = 0; j < lsScheduleValues.length; j++) {
              if (pFlightSchedule.schedules[i] == lsScheduleValues[j].value) {
                lsScheduleValues[j].isActive = true;
              }
            }
          }
          this.lsScheduleValues = lsScheduleValues;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in getScheduleTypeObj",
          err.toString(),
          "getScheduleTypeObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },


    formatDepartureTime(pTime) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("formatDepartureTime");
        if (pTime) {
          retValue = {
            HH: pTime.substring(0, 2),
            mm: pTime.substring(3, 5)
          };
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in formatDepartureTime",
          err.toString(),
          "formatDepartureTime",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    formatFlightNumber(pFlightNumber) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("formatFlightNumber");
        if (pFlightNumber) {
              let indexOfDot = pFlightNumber.indexOf("-");

         retValue=pFlightNumber.substring(indexOfDot+1, pFlightNumber.length)
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in formatFlightNumber",
          err.toString(),
          "formatFlightNumber",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getAircraftTypeObj(pAircraftType) {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getAircraftTypeObj");
             Object.keys(this.GET_ALL_CRS_ENUMS.AircraftType).forEach((key) => {
               if(key==pAircraftType){
              retValue= {
            name : this.GET_ALL_CRS_ENUMS.AircraftType[key],
            code : key
            };
            return true;
               }
             })

    
        } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.SCHEDULE_NEW,
                  "error in getAircraftTypeObj",
                  err.toString(),
                  "getAircraftTypeObj",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 
    assignFlightSchedule(pSchedule) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assignFlightSchedule");
        let flightSchedule = cloneData(this.flightSchedule);
        if (pSchedule) {
          flightSchedule.aircraftType =this.getAircraftTypeObj(pSchedule.aircraft_type);
          flightSchedule.airline = this.getAirlineObj(
            pSchedule.airline_code,
            this.lsAirlines
          );
          flightSchedule.to = this.getRouteObj(
            pSchedule.arrcode,
            this.lsAirportCodes
          );
          flightSchedule.arrivalTime = this.formatDepartureTime(
            pSchedule.arrtime
          );
          flightSchedule.saleableBusinessSeats = pSchedule.business_seats;
          flightSchedule.from = this.getRouteObj(
            pSchedule.depcode,
            this.lsAirportCodes
          );
          flightSchedule.departureTime = this.formatDepartureTime(
            pSchedule.deptime
          );
          flightSchedule.saleableEconomySeats = pSchedule.economy_seats;
            flightSchedule.overbookingBSeats = pSchedule.overbooking_business_seats;
            flightSchedule.overbookingESeats = pSchedule.overbooking_economy_seats;
          if(pSchedule.flight_number){
          flightSchedule.flightNumber = this.formatFlightNumber(pSchedule.flight_number.toString());
          }
          flightSchedule.scheduleType = pSchedule.schedule_type;
          flightSchedule.schedules = pSchedule.schedules;
          flightSchedule.via = this.getRouteObj(
            pSchedule.via_airport_code,
            this.lsAirportCodes
          );
          flightSchedule.scheduleId =pSchedule.scheduleid;
          flightSchedule.arrtime_nextday=pSchedule.arrtime_nextday;
          flightSchedule.status=pSchedule.status;
        }
        retValue = flightSchedule;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in assignFlightSchedule",
          err.toString(),
          "assignFlightSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getLsAircraftType() {
            let retValue;

        try {
          if(BaseConfiguration.isDebug) console.log("getLsAircraftType");
       if (this.GET_ALL_CRS_ENUMS) {
        
          Object.keys(this.GET_ALL_CRS_ENUMS.AircraftType).forEach((key) => {
          let obj= {
            name : this.GET_ALL_CRS_ENUMS.AircraftType[key],
            code : key
            };
            this.lsAircraftType.push(cloneData(obj));
          });
        }
        } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.SCHEDULE_NEW,
                  "error in getLsAircraftType",
                  err.toString(),
                  "getLsAircraftType",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 
  },
 

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      // this.$refs['depTimePick'].$el.classList.add('my-class')
      this.getLsAircraftType();
      this.lsAirportCodes = await this.getAirportCodes();
      this.lsAirlines = await this.getAllAirlines();

      if (this.GET_SEL_FLIGHT_SCHEDULE) {
        let retFlightSchedule = this.assignFlightSchedule(
          this.GET_SEL_FLIGHT_SCHEDULE
        );
        if (retFlightSchedule) {
          this.assignScheduleValuesAsActive(retFlightSchedule);

          this.flightSchedule = retFlightSchedule;
        }
      } else {
        if (BaseConfiguration.defaultFlightSchedule) {
          this.getSchedules(BaseConfiguration.defaultFlightSchedule,true);
        }
        if(BaseConfiguration.defaultAirlineCode&&this.lsAirlines){
          let defAirline=this.getAirlineObj(BaseConfiguration.defaultAirlineCode,this.lsAirlines);
          if(defAirline){
            this.flightSchedule.airline=defAirline;
          }
        }
      }
updateDataEdited(true)
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.SCHEDULE_NEW,
        "error in  Created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  computed: {

      DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
    ...mapGetters("sFlightSchedule", {
      GET_SEL_FLIGHT_SCHEDULE: "GET_SEL_FLIGHT_SCHEDULE"
    }),
      ...mapGetters("sContract", {
      GET_SELECTED_CONTRACT: "GET_SELECTED_CONTRACT",
      GET_ALL_CRS_ENUMS:"GET_ALL_CRS_ENUMS"
    }),
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.SCHEDULE_NEW);
  },

  beforeDestroy() {
    removeClassBody();
  }
};
</script>

<style scoped>
.active {
        background-color: lightblue;
    }
</style>
